import { Link } from 'react-router-dom';
import AnimatedSeparator from '../components/AnimatedSeparator';
import ElaLogo from '../components/ElaLogo';

const openCalendly = (e) => {
    e.preventDefault();
    if (window.Calendly) {
        window.Calendly.initPopupWidget({
            url: 'https://calendly.com/i-elashapira/idea-reality-check?primary_color=f52e72',
        });
    }
};

export default function HomePage() {
    return (
        <div className="page-container">
            <div className="container">

                {/* ── HERO ── */}
                <div className="row page-hero align-items-end">
                    <div className="col-md-8">
                        <h1>Doing startups like a woman;</h1>
                        <h2 style={{ marginBottom: '2rem' }}>
                            Safe, sane, sustainable.
                        </h2>
                        <div className='btn-row' style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                            <Link to="/submit-idea" className="btn-primary">submit your idea</Link>
                            <Link to="/nursery" className="btn-secondary">how it works</Link>
                        </div>
                    </div>
                    <div className="col-md-4 d-none d-md-flex align-items-end justify-content-end">
                        <ElaLogo width="18vw" height="6vw" />
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                {/* ── THE PROBLEM ── */}
                <div className="row">
                    <div className="col-md-5">
                        <h3>
                            Good ideas for profitable startups come from women who know their shit and see what's lacking.
                            We turn your back-of-a-napkin idea into real income.
                        </h3>
                    </div>
                    <div className="col-md-6 offset-md-1">
                        <p>
                            Sacrificing everything on the altar of learning to build a startup is a privilege of the young and the men.
                        </p>
                        <p>
                            Women's ideas remain ideas because their day jobs and the Second Shift at home use most of their time and energy.
                        </p>
                        <p>
                            We solve this by doing the startup work for you, growing your idea into a profitable business that you own.
                        </p>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                {/* ── THE NURSERY TEASER ── */}
                <div className="row">
                    <div className="col-md-3">
                        <h3 style={{ color: '#f52e72' }}>The Nursery — Who & Why</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <h3>Turning women with ideas into women with money.</h3>
                        <div className="spacer" />
                        <p>
                            We are a group of women with almost 100 years of combined experience with tech startups; 
                            we know firsthand how toxic are the tech-bros and the male-oriented VCs.
                        </p>
                        <p>
                            We believe that every woman deserves the opportunity to turn her idea into a successful business,
                            and we believe that a successful business doesn't mean cancerous growth.
                        </p>
                        <p>
                            We created the Startup Doula Nursery to change the current startup ecosystem, 
                            which still expects foundresses to sacrifice their health, their families, 
                            and their financial security for an attempt at building a business.
                        </p>
                        <p>
                            Submit your idea as it is, imperfect and rough. We do the validation for you. 
                            Selected ideas get a fully funded Done-For-You build & launch.
                        </p>
                        <div className="spacer" />
                        <div className='btn-row' style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                            <Link to="/submit-idea" className="btn-primary">submit your idea</Link>
                            <Link to="/about" className="btn-secondary">meet the team</Link>
                        </div>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                {/* ── SECONDARY CTA ── */}
                <div className="row">
                    <div className="col-md-6">
                        <h5>Not ready to submit an idea yet?</h5>
                        <p style={{ paddingBottom: '1.5rem' }}>
                            Start with the free Validation Questions workbook — a set of honest questions that
                            will show you what your idea is made of.
                        </p>
                        <div className='btn-row' style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                            <a
                                href="/workbooks/Idea-Validation-Questions_ElaShapira-StartupDoula.pdf"
                                target="_blank"
                                rel="noreferrer"
                                className="btn-secondary"
                            >
                                Free workbook
                            </a>
                            <a href="/" onClick={openCalendly} className="btn-primary">
                                Book a 30-min call
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
